.fp-logo-with-title
  .fp-logo.-sm
    img(:src='`${patternLibraryUrl}/atom/logo/logo.png`', alt='Logo')
  h1.fp-title {{ title }}
